
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "AdUnion": [
      "HtmlAd",
      "NativeAd"
    ],
    "AddressError": [
      "Error"
    ],
    "AnswerQuestionError": [
      "Error"
    ],
    "AssignAddonError": [
      "Error"
    ],
    "AssignBankAccountToCashAdvanceApplicationError": [
      "Error"
    ],
    "BaseAd": [
      "HtmlAd",
      "NativeAd"
    ],
    "BasePartnerOffer": [
      "Deal",
      "Survey"
    ],
    "BidResponseError": [
      "Error"
    ],
    "CalibrateBudgetsErrors": [
      "Error",
      "GenericCalibrationError"
    ],
    "CancelCashAdvanceApplicationError": [
      "ApplicationNotCancellableError",
      "Error",
      "NoCashAdvanceApplicationError"
    ],
    "ChangeBankAccountErrors": [
      "BlockedInstitutionError",
      "Error",
      "LinkBlockedError",
      "LinkedAccountConflictError",
      "LinkedOverLimitError",
      "MaxAccountChangesReachedError",
      "NoBankAccountError",
      "NoValidPaymentAccountError",
      "SameBankAccountError",
      "UnknownError",
      "UsedForCashAdvanceApplicationError",
      "WithdrawalInProgressError"
    ],
    "ClientEventUnionErrors": [
      "ClientEventError",
      "Error"
    ],
    "ConfirmEmailError": [
      "Error"
    ],
    "ConfirmPhoneError": [
      "Error"
    ],
    "CreateAccountClosureAttemptError": [
      "CreateAccountClosureAttemptValidationError",
      "Error"
    ],
    "CreateCardlyticsSessionTokenError": [
      "Error"
    ],
    "CreateCashAdvanceApplicationError": [
      "Error"
    ],
    "CreateCashAdvanceRequestError": [
      "Error"
    ],
    "CreateChatTokenError": [
      "Error"
    ],
    "CreateChatkitSessionError": [
      "Error"
    ],
    "CreateClosureRequestError": [
      "CreateClosureRequestAlreadyClosingError",
      "CreateClosureRequestCashAdvanceRequestNotRepaidError",
      "CreateClosureRequestUnableToRetrieveACHAccountNumberError",
      "Error"
    ],
    "CreateCtaClickUrlError": [
      "Error"
    ],
    "CreateLinkTokenError": [
      "Error"
    ],
    "CreateMissingRewardReportErrors": [
      "Error",
      "MissingRewardInvalidInputError",
      "MissingRewardValidationError"
    ],
    "CreateOnetimeDepositError": [
      "Error"
    ],
    "CreatePartnerReviewErrors": [
      "Error",
      "InvalidRatingError",
      "NotEligibleError",
      "PartnerNotFoundError",
      "ValidationError"
    ],
    "CreatePaymentAccountError": [
      "AccountTypeError",
      "AddressVerificationError",
      "BadRequest",
      "CVVVerificationError",
      "CardDeclinedError",
      "CardHolderNameVerificationError",
      "CommonError",
      "Conflict",
      "DuplicateCardOtherUserError",
      "DuplicateCardSameUserError",
      "Error",
      "InvalidAddressError",
      "InvalidCardNumberError",
      "InvalidExpirationDateError",
      "MissingCardDataError",
      "MissingUserDataError",
      "PaymentAccountLinkedOverLimitError",
      "PaymentAccountMissingTransferMethodError",
      "RateLimitExceeded"
    ],
    "CreateSubscriptionError": [
      "Error",
      "ExistingSubscriptionError",
      "NoLinkedCardError",
      "NotSupportedSubscriptionProductError"
    ],
    "CreateUpdateLinkTokenError": [
      "Error"
    ],
    "CreateUserError": [
      "Error"
    ],
    "CreateUserFeatureOptInError": [
      "Error"
    ],
    "CreateWithdrawalError": [
      "Error"
    ],
    "ErrorInterface": [
      "AccountDoesNotMatchError",
      "AccountNotFoundError",
      "AccountTypeError",
      "AddressVerificationError",
      "ApplicationNotCancellableError",
      "BadRequest",
      "BlockedInstitutionError",
      "BudgetNotFoundError",
      "CVVVerificationError",
      "CardDeclinedError",
      "CardHolderNameVerificationError",
      "CardInBackoffError",
      "CommonError",
      "Conflict",
      "CreateAccountClosureAttemptValidationError",
      "CreateClosureRequestAlreadyClosingError",
      "CreateClosureRequestCashAdvanceRequestNotRepaidError",
      "CreateClosureRequestUnableToRetrieveACHAccountNumberError",
      "DuplicateCardOtherUserError",
      "DuplicateCardSameUserError",
      "Error",
      "EvaluationAlreadyRunError",
      "ExistingSubscriptionError",
      "FeeAlreadySettledError",
      "GenericBudgetError",
      "GenericCalibrationError",
      "GenericError",
      "InsightNotFoundError",
      "InvalidAddressError",
      "InvalidCardNumberError",
      "InvalidExpirationDateError",
      "InvalidRatingError",
      "InvalidRefreshTokenError",
      "InvalidSubscriptionTransitionError",
      "InvalidUserAttributionError",
      "KeepAccessSubscriptionAlreadyUsedDiscountError",
      "KeepAccessSubscriptionInvalidDiscountError",
      "KeepAccessSubscriptionNoSubscriptionError",
      "LinkBlockedError",
      "LinkedAccountConflictError",
      "LinkedCardInvalidError",
      "LinkedOverLimitError",
      "MaxAccountChangesReachedError",
      "MissingCardDataError",
      "MissingRewardInvalidInputError",
      "MissingRewardValidationError",
      "MissingUserDataError",
      "NoBankAccountError",
      "NoCashAdvanceApplicationError",
      "NoLinkedCardError",
      "NoOutStandingFeeError",
      "NoPaymentAccountError",
      "NoValidPaymentAccountError",
      "NotEligibleError",
      "NotSupportedSubscriptionProductError",
      "OAuthCreateUserExistingOAuthError",
      "OAuthCreateUserExistingUserError",
      "OAuthCreateUserInvalidTokenError",
      "OAuthCreateUserTokenExpiredError",
      "OAuthSignInNotRegisteredError",
      "OAuthSignInUserAccountClosedError",
      "OAuthSignInUserInvalidTokenError",
      "OAuthSignInUserTokenExpiredError",
      "PartnerNotFoundError",
      "PauseCashAdvanceSubscriptionActiveAdvanceError",
      "PauseCashAdvanceSubscriptionCanceledError",
      "PauseCashAdvanceSubscriptionInactiveError",
      "PauseCashAdvanceSubscriptionNoSubscriptionError",
      "PauseSubscriptionActiveAdvanceError",
      "PauseSubscriptionCanceledError",
      "PauseSubscriptionInactiveError",
      "PauseSubscriptionNoSubscriptionError",
      "PaymentAccountLinkedError",
      "PaymentAccountLinkedOverLimitError",
      "PaymentAccountMissingTransferMethodError",
      "PaymentAccountUnusableError",
      "PaymentInProgressError",
      "RateLimitExceeded",
      "RateLimitExceededError",
      "ReferralNotFoundError",
      "RefreshTransactionsUnauthorizedError",
      "RelinkPaymentAccountAlreadyLinkedError",
      "RelinkPaymentAccountCommonError",
      "RelinkPaymentAccountNotCardError",
      "RelinkPaymentAccountNotFoundError",
      "ResumeSubscriptionActiveError",
      "ResumeSubscriptionCanceledError",
      "ResumeSubscriptionLinkedCardUnhealthyError",
      "ResumeSubscriptionNoSubscriptionError",
      "SameBankAccountError",
      "SaveError",
      "TransactionNotFoundError",
      "UnknownError",
      "UnlinkError",
      "UpdateInsightError",
      "UsedForCashAdvanceApplicationError",
      "ValidationError",
      "WithdrawalInProgressError"
    ],
    "FavoritePartnerError": [
      "Error"
    ],
    "HomeBlock": [
      "InternalBlock",
      "OfferFeedBlock",
      "OfferTagBlock"
    ],
    "KeepAccessSubscriptionErrors": [
      "Error",
      "KeepAccessSubscriptionAlreadyUsedDiscountError",
      "KeepAccessSubscriptionInvalidDiscountError",
      "KeepAccessSubscriptionNoSubscriptionError"
    ],
    "LeaderboardUserUnion": [
      "OtherUser",
      "User"
    ],
    "LinkBankAccountError": [
      "Error"
    ],
    "LinkMonitoredAccountError": [
      "Error"
    ],
    "MutePartnerError": [
      "Error"
    ],
    "NotifyReferredUserError": [
      "Error",
      "RateLimitExceededError",
      "ReferralNotFoundError"
    ],
    "OAuthCreateUserError": [
      "Error",
      "OAuthCreateUserExistingOAuthError",
      "OAuthCreateUserExistingUserError",
      "OAuthCreateUserInvalidTokenError",
      "OAuthCreateUserTokenExpiredError"
    ],
    "OAuthSignInUserError": [
      "Error",
      "OAuthSignInNotRegisteredError",
      "OAuthSignInUserAccountClosedError",
      "OAuthSignInUserInvalidTokenError",
      "OAuthSignInUserTokenExpiredError"
    ],
    "PartnerOfferUnion": [
      "Deal",
      "Survey"
    ],
    "PauseCashAdvanceSubscriptionErrors": [
      "Error",
      "PauseCashAdvanceSubscriptionActiveAdvanceError",
      "PauseCashAdvanceSubscriptionCanceledError",
      "PauseCashAdvanceSubscriptionInactiveError",
      "PauseCashAdvanceSubscriptionNoSubscriptionError"
    ],
    "PauseSubscriptionErrors": [
      "Error",
      "PauseSubscriptionActiveAdvanceError",
      "PauseSubscriptionCanceledError",
      "PauseSubscriptionInactiveError",
      "PauseSubscriptionNoSubscriptionError"
    ],
    "PayOutstandingFeeError": [
      "CardInBackoffError",
      "Error",
      "FeeAlreadySettledError",
      "LinkedCardInvalidError",
      "NoOutStandingFeeError",
      "PaymentInProgressError"
    ],
    "PublishEventError": [
      "Error"
    ],
    "Question": [
      "InputAdministrativeArea",
      "InputBoolean",
      "InputButtonSelection",
      "InputChipsSelection",
      "InputCurrency",
      "InputDate",
      "InputGroup",
      "InputListSelection",
      "InputNumber",
      "InputPostalCode",
      "InputStyledButtonSelection",
      "InputText"
    ],
    "RefreshTransactionsErrors": [
      "Error",
      "RefreshTransactionsUnauthorizedError"
    ],
    "RefreshUserSessionError": [
      "Error",
      "InvalidRefreshTokenError"
    ],
    "RegistrationCompleteError": [
      "Error"
    ],
    "RelinkPaymentAccountErrors": [
      "Error",
      "RelinkPaymentAccountAlreadyLinkedError",
      "RelinkPaymentAccountCommonError",
      "RelinkPaymentAccountNotCardError",
      "RelinkPaymentAccountNotFoundError"
    ],
    "RemoveAddonError": [
      "Error"
    ],
    "RepayCashAdvanceRequestError": [
      "Error"
    ],
    "ResendEmailVerificationError": [
      "Error"
    ],
    "ResendPhoneVerificationError": [
      "Error"
    ],
    "ResetPasswordError": [
      "Error"
    ],
    "ResubmitInvestmentApplicationError": [
      "Error"
    ],
    "ResumeSubscriptionErrors": [
      "Error",
      "ResumeSubscriptionActiveError",
      "ResumeSubscriptionCanceledError",
      "ResumeSubscriptionLinkedCardUnhealthyError",
      "ResumeSubscriptionNoSubscriptionError"
    ],
    "RunCashAdvanceEvaluationErrors": [
      "Error",
      "EvaluationAlreadyRunError",
      "NoPaymentAccountError",
      "PaymentAccountUnusableError"
    ],
    "SendSignInSMSError": [
      "Error"
    ],
    "SetOverridesErrors": [
      "Error",
      "GenericError",
      "SaveError",
      "TransactionNotFoundError"
    ],
    "SetUserAttributionError": [
      "Error",
      "InvalidUserAttributionError"
    ],
    "SignInUserError": [
      "Error"
    ],
    "SkipContainerError": [
      "Error"
    ],
    "SubmitCashAdvanceApplicationError": [
      "Error"
    ],
    "SubmitIntegrityResponseError": [
      "Error"
    ],
    "SubmitInvestmentApplicationError": [
      "Error"
    ],
    "SwitchSubscriptionError": [
      "Error",
      "InvalidSubscriptionTransitionError"
    ],
    "Transaction": [
      "AtmSubscriptionFee",
      "AtmSubscriptionFeePayment",
      "CashAdvance",
      "CashAdvanceRepayment",
      "CashAdvanceTip",
      "CashAdvanceTransferFee",
      "DataDividend",
      "InactivityFeeDisplay",
      "InvestmentDeposit",
      "InvestmentWithdrawal",
      "UserOnetimeDeposit",
      "UserRecurringDeposit",
      "Withdrawal",
      "WithdrawalFee"
    ],
    "UnlinkAccountErrors": [
      "AccountNotFoundError",
      "Error",
      "PaymentAccountLinkedError",
      "UnlinkError"
    ],
    "UnlinkBankAccountError": [
      "Error"
    ],
    "UpdateInsightErrors": [
      "Error",
      "InsightNotFoundError",
      "UpdateInsightError"
    ],
    "UpdatePaymentAccountError": [
      "Error"
    ],
    "UpdatePaymentAccountExpirationError": [
      "AccountDoesNotMatchError",
      "AccountTypeError",
      "AddressVerificationError",
      "BadRequest",
      "CVVVerificationError",
      "CardDeclinedError",
      "CardHolderNameVerificationError",
      "CommonError",
      "Conflict",
      "DuplicateCardOtherUserError",
      "DuplicateCardSameUserError",
      "Error",
      "InvalidAddressError",
      "InvalidCardNumberError",
      "InvalidExpirationDateError",
      "MissingCardDataError",
      "MissingUserDataError",
      "PaymentAccountLinkedOverLimitError"
    ],
    "UpdatePhoneError": [
      "Error"
    ],
    "UpdateUserError": [
      "Error"
    ],
    "UpsertBudgetErrors": [
      "BudgetNotFoundError",
      "Error",
      "GenericBudgetError"
    ],
    "UpsertUserFeatureOptInError": [
      "Error"
    ],
    "WithTimestamps": [
      "Deal",
      "HtmlAd",
      "NativeAd",
      "PhoneDetail",
      "Survey",
      "UserPartnerBidResponse"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AdUnion": [
      "HtmlAd",
      "NativeAd"
    ],
    "AddressError": [
      "Error"
    ],
    "AnswerQuestionError": [
      "Error"
    ],
    "AssignAddonError": [
      "Error"
    ],
    "AssignBankAccountToCashAdvanceApplicationError": [
      "Error"
    ],
    "BaseAd": [
      "HtmlAd",
      "NativeAd"
    ],
    "BasePartnerOffer": [
      "Deal",
      "Survey"
    ],
    "BidResponseError": [
      "Error"
    ],
    "CalibrateBudgetsErrors": [
      "Error",
      "GenericCalibrationError"
    ],
    "CancelCashAdvanceApplicationError": [
      "ApplicationNotCancellableError",
      "Error",
      "NoCashAdvanceApplicationError"
    ],
    "ChangeBankAccountErrors": [
      "BlockedInstitutionError",
      "Error",
      "LinkBlockedError",
      "LinkedAccountConflictError",
      "LinkedOverLimitError",
      "MaxAccountChangesReachedError",
      "NoBankAccountError",
      "NoValidPaymentAccountError",
      "SameBankAccountError",
      "UnknownError",
      "UsedForCashAdvanceApplicationError",
      "WithdrawalInProgressError"
    ],
    "ClientEventUnionErrors": [
      "ClientEventError",
      "Error"
    ],
    "ConfirmEmailError": [
      "Error"
    ],
    "ConfirmPhoneError": [
      "Error"
    ],
    "CreateAccountClosureAttemptError": [
      "CreateAccountClosureAttemptValidationError",
      "Error"
    ],
    "CreateCardlyticsSessionTokenError": [
      "Error"
    ],
    "CreateCashAdvanceApplicationError": [
      "Error"
    ],
    "CreateCashAdvanceRequestError": [
      "Error"
    ],
    "CreateChatTokenError": [
      "Error"
    ],
    "CreateChatkitSessionError": [
      "Error"
    ],
    "CreateClosureRequestError": [
      "CreateClosureRequestAlreadyClosingError",
      "CreateClosureRequestCashAdvanceRequestNotRepaidError",
      "CreateClosureRequestUnableToRetrieveACHAccountNumberError",
      "Error"
    ],
    "CreateCtaClickUrlError": [
      "Error"
    ],
    "CreateLinkTokenError": [
      "Error"
    ],
    "CreateMissingRewardReportErrors": [
      "Error",
      "MissingRewardInvalidInputError",
      "MissingRewardValidationError"
    ],
    "CreateOnetimeDepositError": [
      "Error"
    ],
    "CreatePartnerReviewErrors": [
      "Error",
      "InvalidRatingError",
      "NotEligibleError",
      "PartnerNotFoundError",
      "ValidationError"
    ],
    "CreatePaymentAccountError": [
      "AccountTypeError",
      "AddressVerificationError",
      "BadRequest",
      "CVVVerificationError",
      "CardDeclinedError",
      "CardHolderNameVerificationError",
      "CommonError",
      "Conflict",
      "DuplicateCardOtherUserError",
      "DuplicateCardSameUserError",
      "Error",
      "InvalidAddressError",
      "InvalidCardNumberError",
      "InvalidExpirationDateError",
      "MissingCardDataError",
      "MissingUserDataError",
      "PaymentAccountLinkedOverLimitError",
      "PaymentAccountMissingTransferMethodError",
      "RateLimitExceeded"
    ],
    "CreateSubscriptionError": [
      "Error",
      "ExistingSubscriptionError",
      "NoLinkedCardError",
      "NotSupportedSubscriptionProductError"
    ],
    "CreateUpdateLinkTokenError": [
      "Error"
    ],
    "CreateUserError": [
      "Error"
    ],
    "CreateUserFeatureOptInError": [
      "Error"
    ],
    "CreateWithdrawalError": [
      "Error"
    ],
    "ErrorInterface": [
      "AccountDoesNotMatchError",
      "AccountNotFoundError",
      "AccountTypeError",
      "AddressVerificationError",
      "ApplicationNotCancellableError",
      "BadRequest",
      "BlockedInstitutionError",
      "BudgetNotFoundError",
      "CVVVerificationError",
      "CardDeclinedError",
      "CardHolderNameVerificationError",
      "CardInBackoffError",
      "CommonError",
      "Conflict",
      "CreateAccountClosureAttemptValidationError",
      "CreateClosureRequestAlreadyClosingError",
      "CreateClosureRequestCashAdvanceRequestNotRepaidError",
      "CreateClosureRequestUnableToRetrieveACHAccountNumberError",
      "DuplicateCardOtherUserError",
      "DuplicateCardSameUserError",
      "Error",
      "EvaluationAlreadyRunError",
      "ExistingSubscriptionError",
      "FeeAlreadySettledError",
      "GenericBudgetError",
      "GenericCalibrationError",
      "GenericError",
      "InsightNotFoundError",
      "InvalidAddressError",
      "InvalidCardNumberError",
      "InvalidExpirationDateError",
      "InvalidRatingError",
      "InvalidRefreshTokenError",
      "InvalidSubscriptionTransitionError",
      "InvalidUserAttributionError",
      "KeepAccessSubscriptionAlreadyUsedDiscountError",
      "KeepAccessSubscriptionInvalidDiscountError",
      "KeepAccessSubscriptionNoSubscriptionError",
      "LinkBlockedError",
      "LinkedAccountConflictError",
      "LinkedCardInvalidError",
      "LinkedOverLimitError",
      "MaxAccountChangesReachedError",
      "MissingCardDataError",
      "MissingRewardInvalidInputError",
      "MissingRewardValidationError",
      "MissingUserDataError",
      "NoBankAccountError",
      "NoCashAdvanceApplicationError",
      "NoLinkedCardError",
      "NoOutStandingFeeError",
      "NoPaymentAccountError",
      "NoValidPaymentAccountError",
      "NotEligibleError",
      "NotSupportedSubscriptionProductError",
      "OAuthCreateUserExistingOAuthError",
      "OAuthCreateUserExistingUserError",
      "OAuthCreateUserInvalidTokenError",
      "OAuthCreateUserTokenExpiredError",
      "OAuthSignInNotRegisteredError",
      "OAuthSignInUserAccountClosedError",
      "OAuthSignInUserInvalidTokenError",
      "OAuthSignInUserTokenExpiredError",
      "PartnerNotFoundError",
      "PauseCashAdvanceSubscriptionActiveAdvanceError",
      "PauseCashAdvanceSubscriptionCanceledError",
      "PauseCashAdvanceSubscriptionInactiveError",
      "PauseCashAdvanceSubscriptionNoSubscriptionError",
      "PauseSubscriptionActiveAdvanceError",
      "PauseSubscriptionCanceledError",
      "PauseSubscriptionInactiveError",
      "PauseSubscriptionNoSubscriptionError",
      "PaymentAccountLinkedError",
      "PaymentAccountLinkedOverLimitError",
      "PaymentAccountMissingTransferMethodError",
      "PaymentAccountUnusableError",
      "PaymentInProgressError",
      "RateLimitExceeded",
      "RateLimitExceededError",
      "ReferralNotFoundError",
      "RefreshTransactionsUnauthorizedError",
      "RelinkPaymentAccountAlreadyLinkedError",
      "RelinkPaymentAccountCommonError",
      "RelinkPaymentAccountNotCardError",
      "RelinkPaymentAccountNotFoundError",
      "ResumeSubscriptionActiveError",
      "ResumeSubscriptionCanceledError",
      "ResumeSubscriptionLinkedCardUnhealthyError",
      "ResumeSubscriptionNoSubscriptionError",
      "SameBankAccountError",
      "SaveError",
      "TransactionNotFoundError",
      "UnknownError",
      "UnlinkError",
      "UpdateInsightError",
      "UsedForCashAdvanceApplicationError",
      "ValidationError",
      "WithdrawalInProgressError"
    ],
    "FavoritePartnerError": [
      "Error"
    ],
    "HomeBlock": [
      "InternalBlock",
      "OfferFeedBlock",
      "OfferTagBlock"
    ],
    "KeepAccessSubscriptionErrors": [
      "Error",
      "KeepAccessSubscriptionAlreadyUsedDiscountError",
      "KeepAccessSubscriptionInvalidDiscountError",
      "KeepAccessSubscriptionNoSubscriptionError"
    ],
    "LeaderboardUserUnion": [
      "OtherUser",
      "User"
    ],
    "LinkBankAccountError": [
      "Error"
    ],
    "LinkMonitoredAccountError": [
      "Error"
    ],
    "MutePartnerError": [
      "Error"
    ],
    "NotifyReferredUserError": [
      "Error",
      "RateLimitExceededError",
      "ReferralNotFoundError"
    ],
    "OAuthCreateUserError": [
      "Error",
      "OAuthCreateUserExistingOAuthError",
      "OAuthCreateUserExistingUserError",
      "OAuthCreateUserInvalidTokenError",
      "OAuthCreateUserTokenExpiredError"
    ],
    "OAuthSignInUserError": [
      "Error",
      "OAuthSignInNotRegisteredError",
      "OAuthSignInUserAccountClosedError",
      "OAuthSignInUserInvalidTokenError",
      "OAuthSignInUserTokenExpiredError"
    ],
    "PartnerOfferUnion": [
      "Deal",
      "Survey"
    ],
    "PauseCashAdvanceSubscriptionErrors": [
      "Error",
      "PauseCashAdvanceSubscriptionActiveAdvanceError",
      "PauseCashAdvanceSubscriptionCanceledError",
      "PauseCashAdvanceSubscriptionInactiveError",
      "PauseCashAdvanceSubscriptionNoSubscriptionError"
    ],
    "PauseSubscriptionErrors": [
      "Error",
      "PauseSubscriptionActiveAdvanceError",
      "PauseSubscriptionCanceledError",
      "PauseSubscriptionInactiveError",
      "PauseSubscriptionNoSubscriptionError"
    ],
    "PayOutstandingFeeError": [
      "CardInBackoffError",
      "Error",
      "FeeAlreadySettledError",
      "LinkedCardInvalidError",
      "NoOutStandingFeeError",
      "PaymentInProgressError"
    ],
    "PublishEventError": [
      "Error"
    ],
    "Question": [
      "InputAdministrativeArea",
      "InputBoolean",
      "InputButtonSelection",
      "InputChipsSelection",
      "InputCurrency",
      "InputDate",
      "InputGroup",
      "InputListSelection",
      "InputNumber",
      "InputPostalCode",
      "InputStyledButtonSelection",
      "InputText"
    ],
    "RefreshTransactionsErrors": [
      "Error",
      "RefreshTransactionsUnauthorizedError"
    ],
    "RefreshUserSessionError": [
      "Error",
      "InvalidRefreshTokenError"
    ],
    "RegistrationCompleteError": [
      "Error"
    ],
    "RelinkPaymentAccountErrors": [
      "Error",
      "RelinkPaymentAccountAlreadyLinkedError",
      "RelinkPaymentAccountCommonError",
      "RelinkPaymentAccountNotCardError",
      "RelinkPaymentAccountNotFoundError"
    ],
    "RemoveAddonError": [
      "Error"
    ],
    "RepayCashAdvanceRequestError": [
      "Error"
    ],
    "ResendEmailVerificationError": [
      "Error"
    ],
    "ResendPhoneVerificationError": [
      "Error"
    ],
    "ResetPasswordError": [
      "Error"
    ],
    "ResubmitInvestmentApplicationError": [
      "Error"
    ],
    "ResumeSubscriptionErrors": [
      "Error",
      "ResumeSubscriptionActiveError",
      "ResumeSubscriptionCanceledError",
      "ResumeSubscriptionLinkedCardUnhealthyError",
      "ResumeSubscriptionNoSubscriptionError"
    ],
    "RunCashAdvanceEvaluationErrors": [
      "Error",
      "EvaluationAlreadyRunError",
      "NoPaymentAccountError",
      "PaymentAccountUnusableError"
    ],
    "SendSignInSMSError": [
      "Error"
    ],
    "SetOverridesErrors": [
      "Error",
      "GenericError",
      "SaveError",
      "TransactionNotFoundError"
    ],
    "SetUserAttributionError": [
      "Error",
      "InvalidUserAttributionError"
    ],
    "SignInUserError": [
      "Error"
    ],
    "SkipContainerError": [
      "Error"
    ],
    "SubmitCashAdvanceApplicationError": [
      "Error"
    ],
    "SubmitIntegrityResponseError": [
      "Error"
    ],
    "SubmitInvestmentApplicationError": [
      "Error"
    ],
    "SwitchSubscriptionError": [
      "Error",
      "InvalidSubscriptionTransitionError"
    ],
    "Transaction": [
      "AtmSubscriptionFee",
      "AtmSubscriptionFeePayment",
      "CashAdvance",
      "CashAdvanceRepayment",
      "CashAdvanceTip",
      "CashAdvanceTransferFee",
      "DataDividend",
      "InactivityFeeDisplay",
      "InvestmentDeposit",
      "InvestmentWithdrawal",
      "UserOnetimeDeposit",
      "UserRecurringDeposit",
      "Withdrawal",
      "WithdrawalFee"
    ],
    "UnlinkAccountErrors": [
      "AccountNotFoundError",
      "Error",
      "PaymentAccountLinkedError",
      "UnlinkError"
    ],
    "UnlinkBankAccountError": [
      "Error"
    ],
    "UpdateInsightErrors": [
      "Error",
      "InsightNotFoundError",
      "UpdateInsightError"
    ],
    "UpdatePaymentAccountError": [
      "Error"
    ],
    "UpdatePaymentAccountExpirationError": [
      "AccountDoesNotMatchError",
      "AccountTypeError",
      "AddressVerificationError",
      "BadRequest",
      "CVVVerificationError",
      "CardDeclinedError",
      "CardHolderNameVerificationError",
      "CommonError",
      "Conflict",
      "DuplicateCardOtherUserError",
      "DuplicateCardSameUserError",
      "Error",
      "InvalidAddressError",
      "InvalidCardNumberError",
      "InvalidExpirationDateError",
      "MissingCardDataError",
      "MissingUserDataError",
      "PaymentAccountLinkedOverLimitError"
    ],
    "UpdatePhoneError": [
      "Error"
    ],
    "UpdateUserError": [
      "Error"
    ],
    "UpsertBudgetErrors": [
      "BudgetNotFoundError",
      "Error",
      "GenericBudgetError"
    ],
    "UpsertUserFeatureOptInError": [
      "Error"
    ],
    "WithTimestamps": [
      "Deal",
      "HtmlAd",
      "NativeAd",
      "PhoneDetail",
      "Survey",
      "UserPartnerBidResponse"
    ]
  }
};
      export default result;
    